import get from 'lodash/get'

import {reducer} from './helpers'
import {
  APPLY_PROMO_CODE_FAILURE,
  APPLY_PROMO_CODE_PENDING,
  APPLY_PROMO_CODE_SUCCESS,
  DISPLAY_OVERRIDE,
  HIDE_OVERRIDE,
  RESET_PROMO,
  SET_ERROR,
  UPDATE_PROMO_STATUS_MESSAGE,
} from '../actions/promo'

const initialState = {
  currentlyAppliedPromoCode: '',
  hasError: false,
  isApplyPromoCodePending: false,
  isOverrideVisible: false,
  statusMessage: '',
}

export default reducer(initialState, (state, action) => {
  switch (action.type) {
    case APPLY_PROMO_CODE_PENDING:
      return {
        isApplyPromoCodePending: true,
      }
    case APPLY_PROMO_CODE_SUCCESS:
      return {
        currentlyAppliedPromoCode: get(action, 'payload.appliedCode', '').toLowerCase(),
        hasError: false,
        isApplyPromoCodePending: false,
        isOverrideVisible: false,
        statusMessage: `Promo applied! You saved ${get(action, 'payload.discountAmount')}`,
      }
    case APPLY_PROMO_CODE_FAILURE:
      return {
        currentlyAppliedPromoCode: '',
        hasError: true,
        isApplyPromoCodePending: false,
        isOverrideVisible: false,
        statusMessage: action.payload,
      }
    case DISPLAY_OVERRIDE:
      return {
        isOverrideVisible: true,
        statusMessage: '',
      }
    case HIDE_OVERRIDE:
      return {
        isOverrideVisible: false,
      }
    case RESET_PROMO:
      return {
        hasError: false,
        isApplyPromoCodePending: false,
        isOverrideVisible: false,
        statusMessage: '',
      }
    case SET_ERROR:
      return {
        hasError: action.payload,
      }
    case UPDATE_PROMO_STATUS_MESSAGE:
      return {
        statusMessage: action.payload,
      }
    default:
      return null
  }
})
